import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";

import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import TokenPurchaseHistoryReportCard from "../../components/report/TokenPurchaseHistoryReportCard";

const TokenPurchaseHistory = ({ token, admin }) => {

    const history = useHistory();

    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (!admin || !admin.token_report) {
            history.push('/admin/dashboard')
        }
    }, [])

    const handleToggle = () => {
        setToggled(!toggled);
    }

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />
            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />
                <div className="admin-content">
                    <TokenPurchaseHistoryReportCard
                        token={token}
                        country={admin?.country}
                        role="operator"
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        admin: state.admin.admin,
        token: state.admin.token,
    };
};

export default connect(mapStateToProps, null)(TokenPurchaseHistory);